import http from 'plugins/axios'

export default {
  //更新后的查询所有用户信息
  getUserList({
    page,
    size,
    startTime,
    endTime,
    symbolId,
    userId,
    channelId,
    channelUserId,
    orderId,
  }) {
    return http.get({
      url: `/ta/admin/channel/order/list?page=${page}&size=${size}&symbolId=${symbolId}&startTime=${startTime}&endTime=${endTime}&userId=${userId}&orderId=${orderId}&channelUserId=${channelUserId}&channelId=${channelId}`,
    })
  },
  //获取交易对列表
  getSymbolList() {
    return http.get({
      url: '/ta/admin/tenant/symbol/getSymbolList',
      data: { type: 'CONTRACT' },
    })
  },

  //获取币种列表
  getCoinList() {
    return http.get({
      url: '/channel/common/coinList',
    })
  },
  getHistory(params) {
    return http.get({
      url: '/ta/admin/channel/position/listLog',
      params,
    })
  },
  exportExcel(params) {
    return http.get({
      url: '/ta/admin/channel/position/listLog/excel',
      params,
      responseType: 'blob',
    })
  },
  getHistoryInfo(params) {
    return http.get({
      url: '/ta/admin/channel/position/listLogTotalInfo',
      params,
    })
  },
  delPositionId(positionId) {
    return http.post({
      url: `/ta/admin/channel/position/deleteHistory?positionId=${positionId}`,
    })
  },
  addUserType(data) {
    return http.post({
      url: `/ta/admin/tenant/activity/addUserType`,
      data,
    })
  },
}
